(function () {
  var handle = 'deye-data-logger-series-wifi-4g-ethernet-monitoring-accessories';
  var oldHandle = 'logger-dl1000b-wifi';
  var isAustralia = window.location.pathname === '/en-au' || window.location.pathname.indexOf('/en-au/') === 0;

  if (!isAustralia) return;

  var product = {
    title: 'Deye Data Logger Series | WiFi / 4G / Ethernet Monitoring Accessories',
    image: 'https://cdn.shopify.com/s/files/1/0976/1040/0053/files/www.deyeinverter.com_deyeinverter_2025_08_12_stick-logger.png?v=1780299762',
    alt: 'Deye Data Logger Series WiFi, 4G and Ethernet monitoring accessories',
    url: '/en-au/collections/accessories/products/' + handle
  };

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function createMenuCard() {
    var item = document.createElement('li');
    item.className = 'header__submenu-products-item';
    item.innerHTML =
      '<a href="' + product.url + '" class="header__submenu-products-link" aria-label="' + escapeHtml(product.title) + '">' +
        '<div class="header__submenu-products-media">' +
          '<img src="' + product.image + '&width=240" srcset="' + product.image + '&width=120 120w, ' + product.image + '&width=180 180w, ' + product.image + '&width=240 240w" width="240" height="240" loading="lazy" class="header__submenu-products-image" alt="' + escapeHtml(product.alt) + '">' +
        '</div>' +
        '<div class="header__submenu-products-content">' +
          '<span class="header__submenu-products-title">' + escapeHtml(product.title) + '</span>' +
        '</div>' +
      '</a>';
    return item;
  }

  function updateMenuCard(item) {
    if (!item) return;
    var link = item.querySelector('a[href*="/products/' + handle + '"]');
    if (link) {
      link.setAttribute('href', product.url);
      link.setAttribute('aria-label', product.title);
    }
    var title = item.querySelector('.header__submenu-products-title');
    if (title) title.textContent = product.title;
    var image = item.querySelector('img');
    if (image) {
      image.setAttribute('alt', product.alt);
      if (!image.getAttribute('src') || image.getAttribute('src').indexOf(product.image) === -1) {
        image.setAttribute('src', product.image + '&width=240');
      }
    }
  }

  function ensureHeaderMenuCard() {
    document.querySelectorAll('.header__submenu-products').forEach(function (block) {
      var heading = block.querySelector('.header__submenu-products-heading');
      var list = block.querySelector('.header__submenu-products-list');
      if (!heading || !list) return;
      if (heading.textContent.trim().toLowerCase() !== 'accessories') return;

      list.querySelectorAll('a[href*="/products/' + oldHandle + '"], a[href*="/collections/accessories/products/' + oldHandle + '"]').forEach(function (link) {
        var item = link.closest('.header__submenu-products-item, li');
        if (item) item.remove();
      });

      var firstItem = null;
      list.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function (link, index) {
        var item = link.closest('.header__submenu-products-item, li');
        if (!item) return;
        if (index > 0) {
          item.remove();
        } else {
          firstItem = item;
          updateMenuCard(item);
          if (item !== list.firstElementChild) list.insertBefore(item, list.firstElementChild);
        }
      });

      if (!firstItem) {
        list.insertBefore(createMenuCard(), list.firstElementChild);
      }
    });
  }

  function ensureCollectionCardVisible() {
    if (window.location.pathname.indexOf('/en-au/collections/accessories') !== 0) return;
    document.querySelectorAll('[data-product="' + handle + '"]').forEach(function (card) {
      var outer = card.closest('.collection-product-card') || card;
      outer.hidden = false;
      outer.style.removeProperty('display');
    });
  }

  function run() {
    ensureHeaderMenuCard();
    ensureCollectionCardVisible();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    run();
    setTimeout(run, 250);
    setTimeout(run, 1000);
  });

  document.addEventListener('shopify:section:load', run);
})();
